import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { getHotArticles, getCategoryName } from '@/utils/content';

export default function HotRankingSection() {
  const ranking = getHotArticles(6);
  const maxHot = ranking[0]?.hot || 1;

  return (
    <section id="ranking" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/45">
      <div className="mx-auto w-full px-4 py-14 md:px-10 md:py-20">
        <SectionHeading
          kicker="HOT LIST · 热瓜榜"
          title="过去 24 小时，读者点得最多的六条"
          description="榜单按站内阅读与转发综合计算，每两小时更新一次。"
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-x-10">
          {ranking.map((item, index) => {
            const percent = Math.max(18, Math.round((item.hot / maxHot) * 100));
            return (
              <article key={item.id} className="group">
                <Link to={`/article/${item.id}`} className="flex items-start gap-4">
                  <span
                    className={`font-heading text-3xl font-black leading-none md:text-4xl ${
                      index < 3 ? 'text-accent-500' : 'text-background-400'
                    }`}
                  >
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div className="min-w-0 flex-1 border-b border-background-200/70 pb-4">
                    <div className="mb-1.5 flex flex-wrap items-center gap-2 text-xs">
                      <span className="text-primary-400">{getCategoryName(item.categorySlug)}</span>
                      <span className="text-foreground-600">{item.date}</span>
                    </div>
                    <h3 className="line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-100 transition-colors group-hover:text-primary-300">
                      {item.title}
                    </h3>
                    <div className="mt-2.5 flex items-center gap-3">
                      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-primary-600 to-primary-400"
                          style={{ width: `${percent}%` }}
                        ></div>
                      </div>
                      <span className="shrink-0 text-xs text-foreground-500">
                        {item.hot.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}